import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f701d5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-page__form-inner-container checkout-page__inner-container checkout-delivery-form" }
const _hoisted_2 = { class: "checkout-page__form-header-container" }
const _hoisted_3 = { class: "checkout-page__form-header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "checkout-page__form-overview-delivery" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "checkout-page__form-overview-delivery-name" }
const _hoisted_8 = {
  key: 1,
  class: "checkout-page__form-overview-delivery-price"
}
const _hoisted_9 = {
  key: 2,
  class: "checkout-page__form-overview-delivery-price"
}
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "checkout-page__delivery-method-info-container" }
const _hoisted_12 = { class: "checkout-page__delivery-method-info" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  key: 0,
  class: "checkout-page__delivery-method-price"
}
const _hoisted_16 = {
  key: 1,
  class: "checkout-page__delivery-method-price"
}
const _hoisted_17 = {
  key: 0,
  class: "checkout-page__delivery__service-points"
}
const _hoisted_18 = { class: "checkout-page__delivery__service-points__header" }
const _hoisted_19 = {
  key: 1,
  class: "checkout-delivery-form__button-container"
}
const _hoisted_20 = {
  key: 0,
  class: "checkout-page__form-button-container checkout-page__form-button-container--delivery"
}
const _hoisted_21 = ["disabled"]

import dictionary from "@/i18n/dictionary.json";
import { computed, onMounted, ref, watch } from "vue";
import { Checkout, ShippingOption } from "@/models/Checkout";
import TressRadioInput from "@/components/TressRadioInput.vue";
import { CheckoutApi, DataLayerApi } from "@/services/Api";
import TressCheckoutServicePoint from "@/components/TressCheckoutServicePoint.vue";
import { IServicePoint } from "@/models/IServicePoint";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import { useCheckout } from "@/store/useCheckout";
import { TressExceptions } from "@/code/TressExceptions";
import { useCart } from "@/store/useCart";
import { useAsyncSpinner } from "@/services/Spinner";

const servicePointAgentCodePostNord = "POSTNORD_COLLECT";
const servicePointAgentCodeDhl = "DHL_SERVICEPOINT";

export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutDeliveryForm',
  props: {
  openAccordionId: {
    type: String,
    required: true,
  },
  openAccordionHeight: {
    type: [String, Number],
    required: true,
  },
  isFormTouched: {
    type: Boolean,
    required: true,
  },
  showAsB2b: {
    type: Boolean,
    required: true,
  },
},
  emits: {
  edit: () => true,
  submit: (checkout: Checkout) => true,
},
  setup(__props, { emit }) {



const checkout = useCheckout();
const cart = useCart();

let deliveryMethods = ref<ShippingOption[]>([]);

const { t } = useI18n();



const selectedDeliveryMethodId = ref<string>(checkout.deliveryMethodId);
const selectedServicePointId = ref<string>(checkout.servicePointId);

const isFormDirty = computed(() => !!selectedDeliveryMethodId.value);

const selectedDeliveryMethod = computed(() => {
  return deliveryMethods.value.find((x) => x.id === selectedDeliveryMethodId.value);
});

const deliveryMethodIsValid = computed(() => {
  if (selectedDeliveryMethod.value) {
    if (selectedDeliveryMethod.value.id === servicePointAgentCodePostNord || selectedDeliveryMethod.value.id === servicePointAgentCodeDhl) {
      return chosenServicePoint.value;
    }
    return true;
  }
  return false;
});

const chosenServicePoint = computed(() => {
  const foundServicePoint = servicePoints.value?.find((x) => x.id === selectedServicePointId.value);
  return foundServicePoint || (servicePoints.value && servicePoints.value[0]);
});

const response = ref<Checkout>(checkout);

const onEdit = () => {
  emit("edit");
};

const loadDeliveryMethods = async () => {
  try {
    await useAsyncSpinner(
      async () => {
        const deliveryOptionsRes = await CheckoutApi.getShippingOptions();
        deliveryMethods.value = deliveryOptionsRes.shippingOptions;

        if (!checkout.deliveryMethodId) {
          const deliveryPrices = deliveryMethods.value.map((a) => a.price);
          const cheapest = Math.min(...deliveryPrices);
          const cheapestDeliveryMethod = deliveryMethods.value.find((d) => d.price === cheapest);

          const response = await CheckoutApi.setDelivery({
            freightAmount: cheapestDeliveryMethod!.price,
            freightAmountIncVat: cheapestDeliveryMethod!.priceIncVat,
          });

          cart.set(response.basket);
        }
      },
      {},
      1
    );
  } catch (e: any) {
    const error = Number(TressExceptions[e]);
    let message = "";
    switch (error) {
      case TressExceptions.Checkout_NoShippingOptions:
        message = t(dictionary.checkout.noShippingOptionsError);
        break;
      case TressExceptions.Checkout_GetShippingOptions:
        message = t(dictionary.checkout.getShippingOptionsError);
        break;
    }
    await Swal.fire<void>({
      icon: "error",
      text: message,
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "btn btn-success button button--default",
      },
      buttonsStyling: false,
    });
  }
};

onMounted(() => {
  if (checkout.deliveryMethodId) {
    onDeliveryChange();
  }
});
const onSubmit = async () => {
  try {
    emit("submit", response.value!);
  } catch {
    await Swal.fire<void>({
      icon: "error",
      text: t(dictionary.checkout.setDeliveryError),
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "btn btn-success button button--default",
      },
      buttonsStyling: false,
    });
  }
};
const servicePoints = ref<Array<IServicePoint>>();
const onDeliveryChange = async () => {
  if (selectedDeliveryMethodId.value === servicePointAgentCodePostNord || selectedDeliveryMethodId.value === servicePointAgentCodeDhl) {
    try {
      servicePoints.value = undefined;
      //const postNordRes = await CheckoutApi.getPostNordServicePoints(checkout.shippingPostalCode);
      //const DhlRes = await CheckoutApi.getDhlServicePoints(checkout.shippingPostalCode);
      //const res = [...postNordRes, ...DhlRes];
      if (selectedDeliveryMethodId.value === servicePointAgentCodePostNord) {
        servicePoints.value = await CheckoutApi.getPostNordServicePoints(checkout.shippingPostalCode);
      }
      if (selectedDeliveryMethodId.value === servicePointAgentCodeDhl) {
        servicePoints.value = await CheckoutApi.getDhlServicePoints(checkout.shippingPostalCode);
      }
    } catch (e: any) {
      await Swal.fire<void>({
        icon: "error",
        text: t(dictionary.checkout.getServicePointsError),
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: true,
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-success button button--default",
        },
        buttonsStyling: false,
      });
    }
  } else {
    servicePoints.value = undefined;
  }
  if (selectedDeliveryMethod.value) {
    try {
      const resp = await CheckoutApi.setDelivery({
        shippingAgentCode: selectedDeliveryMethod.value!.id,
        freightAmount: selectedDeliveryMethod.value!.price,
        freightAmountIncVat: selectedDeliveryMethod.value!.priceIncVat,
        servicePoint: chosenServicePoint.value!,
      });
      await checkout.setDeliveryMethodId(selectedDeliveryMethod.value!.id);
      response.value = resp;
      cart.set(resp.basket);
      DataLayerApi.updateAddShippingInfoEvent();
    } catch (e) {
      await Swal.fire<void>({
        icon: "error",
        text: t(dictionary.checkout.getServicePointsError),
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: true,
        showCloseButton: true,
        customClass: {
          confirmButton: "btn btn-success button button--default",
        },
        buttonsStyling: false,
      });
    }
  }
};

const onServicePointChange = async (servicePoint: IServicePoint) => {
  selectedServicePointId.value = servicePoint.id;
  try {
    const resp = await CheckoutApi.setDelivery({
      shippingAgentCode: selectedDeliveryMethod.value!.id,
      freightAmount: selectedDeliveryMethod.value!.price,
      freightAmountIncVat: selectedDeliveryMethod.value!.priceIncVat,
      servicePoint: chosenServicePoint.value!,
    });
    await checkout.setDeliveryMethodId(selectedDeliveryMethod.value!.id);
    await checkout.setServicePointId(chosenServicePoint.value!.id);
    response.value = resp;
    cart.set(resp.basket);
  } catch (e) {
    await Swal.fire<void>({
      icon: "error",
      text: t(dictionary.checkout.getServicePointsError),
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "btn btn-success button button--default",
      },
      buttonsStyling: false,
    });
  }
};

onMounted(async () => {
  if (checkout.shippingPostalCode) {
    // Load delivery methods if the user has entered a postal code.
    await loadDeliveryMethods();
  }
});

watch(
  () => checkout.shippingPostalCode,
  async () => {
    // Load updated delivery methods if the user has changed their postal code.
    checkout.clearDeliveryMethod();
    servicePoints.value = undefined;
    deliveryMethods.value = [];
    await loadDeliveryMethods();
  }
);

watch(
  () => cart.loading,
  async (newValue) => {
    if (newValue == false && checkout.shippingPostalCode) {
      // Load updated delivery methods if the user has made changes to basket
      checkout.clearDeliveryMethod();
      servicePoints.value = undefined;
      deliveryMethods.value = [];
      await loadDeliveryMethods();
    }
  }
);

watch(
  () => checkout.deliveryMethodId,
  async (newValue) => {
    if (newValue === "") {
      // Selected delivery method has been resetted.
      deliveryMethods.value = [];
      selectedDeliveryMethodId.value = "";
      await loadDeliveryMethods();
    }
  }
);

const hasManyServicePoints = computed(() => {
  if (servicePoints.value) {
    return servicePoints.value.length > 3;
  }
  return false;
});
const initialServicePoints = computed(() => {
  return servicePoints.value?.slice(0, 4);
});
const restServicePoints = computed(() => {
  return servicePoints.value?.slice(4);
});
const showAllServicePoints = ref<boolean>(false);
const toggleShowAllServicePoints = () => {
  showAllServicePoints.value = !showAllServicePoints.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.step2)), 1),
      (__props.openAccordionId != 'step2' && __props.isFormTouched)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "checkout-page__form-button-change",
            onClick: onEdit
          }, _toDisplayString(_ctx.$t(_unref(dictionary).common.change)), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.openAccordionId !== 'step2' && selectedDeliveryMethod.value && isFormDirty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (selectedDeliveryMethod.value.imageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: selectedDeliveryMethod.value.imageUrl,
                  class: "checkout-page__form-overview-delivery-logo"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_7, _toDisplayString(selectedDeliveryMethod.value.name), 1),
            (__props.showAsB2b)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(selectedDeliveryMethod.value.priceFormatted), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(selectedDeliveryMethod.value.priceIncVatFormatted), 1))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      style: _normalizeStyle({ height: __props.openAccordionId == 'step2' ? __props.openAccordionHeight : 0 }),
      class: "checkout-page__delivery-methods"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryMethods), (deliveryMethod) => {
        return (_openBlock(), _createElementBlock("div", {
          key: deliveryMethod.id,
          class: "checkout-page__delivery-method"
        }, [
          _createElementVNode("label", {
            class: "checkout-page__delivery-method-row",
            for: deliveryMethod.id
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(TressRadioInput, {
                  id: deliveryMethod.id,
                  modelValue: selectedDeliveryMethodId.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDeliveryMethodId).value = $event)),
                  value: deliveryMethod.id,
                  name: "deliverymethod",
                  onChange: onDeliveryChange
                }, null, 8, ["id", "modelValue", "value"]),
                (deliveryMethod.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: deliveryMethod.imageUrl,
                      class: "checkout-page__delivery-method-logo"
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                _createElementVNode("label", {
                  class: "checkout-page__delivery-method-name",
                  for: deliveryMethod.id
                }, _toDisplayString(deliveryMethod.name), 9, _hoisted_14)
              ]),
              (__props.showAsB2b)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(deliveryMethod.priceFormatted), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(deliveryMethod.priceIncVatFormatted), 1))
            ]),
            (selectedDeliveryMethodId.value == deliveryMethod.id && servicePoints.value && (deliveryMethod.id === servicePointAgentCodePostNord || deliveryMethod.id === servicePointAgentCodeDhl))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.selectServicePoint)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initialServicePoints.value, (servicePoint) => {
                    return (_openBlock(), _createBlock(TressCheckoutServicePoint, {
                      key: servicePoint.id,
                      model: chosenServicePoint.value,
                      "service-point": servicePoint,
                      onChange: onServicePointChange
                    }, null, 8, ["model", "service-point"]))
                  }), 128)),
                  (hasManyServicePoints.value && showAllServicePoints.value)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(restServicePoints.value, (servicePoint) => {
                        return (_openBlock(), _createBlock(TressCheckoutServicePoint, {
                          key: servicePoint.id,
                          model: chosenServicePoint.value,
                          "service-point": servicePoint,
                          onChange: onServicePointChange
                        }, null, 8, ["model", "service-point"]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (hasManyServicePoints.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("button", {
                          onClick: toggleShowAllServicePoints,
                          type: "button",
                          class: "checkout-page__delivery__service-points__button"
                        }, [
                          (showAllServicePoints.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).checkout.showLessServicePoints)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).checkout.showAllServicePoints)), 1)
                              ], 64))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_10)
        ]))
      }), 128)),
      (_unref(deliveryMethods).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "checkout-page__form-button",
              type: "button",
              onClick: onSubmit,
              disabled: !deliveryMethodIsValid.value
            }, _toDisplayString(_ctx.$t(_unref(dictionary).common.continue)), 9, _hoisted_21)
          ]))
        : _createCommentVNode("", true)
    ], 4), [
      [_vShow, __props.openAccordionId === 'step2']
    ])
  ]))
}
}

})